
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wert-check",
      function () {
        return require("private-next-pages/wert-check/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wert-check"])
      });
    }
  